module.exports = __webpack_public_path__ + "static/media/dydx.0f8beaf4.svg";